import de from '@translations/de/productForm.json';
import en from '@translations/en/productForm.json';
import pl from '@translations/pl/productForm.json';
import sl from '@translations/sl/productForm.json';
import uk from '@translations/uk/productForm.json';
import bg from '@translations/bg/productForm.json';
import cz from '@translations/cz/productForm.json';
import fr from '@translations/fr/productForm.json';
import gr from '@translations/gr/productForm.json';
import it from '@translations/it/productForm.json';
import pr from '@translations/pr/productForm.json';
import ru from '@translations/ru/productForm.json';
import sk from '@translations/sk/productForm.json';
import sp from '@translations/sp/productForm.json';
import tr from '@translations/tr/productForm.json';
import hu from '@translations/hu/productForm.json';
import { ITranslations } from '@/types/common';
import { ProductFormTransFields } from './types';

export const productFormTranslations: ITranslations<ProductFormTransFields> = {
  name: 'productForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
